import {
  AgentEndpoints,
  type CommonResponse,
  RequestMethods,
  useRequest,
} from '@shared/index';

import type {
  GetClaimsDraftRequestParams,
  GetClaimsDraftResponse,
} from './use-get-claims-draft.types';

export const useGetClaimsDraft = (request: GetClaimsDraftRequestParams) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    GetClaimsDraftRequestParams,
    GetClaimsDraftResponse,
    CommonResponse
  >({
    params: {
      key: 'getClaimsDraft',
      method: RequestMethods.POST,
      url: `${AgentEndpoints.AGENTS}/claims/draft`,
      request,
      fetchManual: true,
    },
    config: { responseType: 'blob' },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
